
export type confirmPaymentDataProps={
        screenCta?: {
            displayText: string;
            type: string;
            value: string;
        };
        transferData?: { 
            bgColor: string;
            iconUrl: string;
            title: {
                text: string;
                style: {
                    textStyle: string;
                    textColor: string;
                };
            };
            bankTransferData: {
                bgColor: string;
                iconUrl: string;
                keyData: {
                    text: string;
                    style: {
                        textStyle: string;
                        textColor: string;
                    };
                };
                valueData: {
                    text: string;
                    isStrikeThrough: boolean;
                    style: {
                        textStyle: string;
                        textColor: string;
                    };
                };
                modeData: {
                    iconUrl: string;
                    mode: {
                        text: string;
                        isStrikeThrough: boolean;
                        style: {
                            textStyle: string;
                            textColor: string;
                        };
                    };
                };
            };
        };
    }

export type BankCardProps = {
    backWithdrawalHandler?: () => void;
}

export type WithdrawalCardProps = {
    paymentMethods?: any;
    dataFromUpiBank?: any;
    normalWithdrawalData?: any;
    moveToNextStepPaymentConfirmScreen?: (paymentMethod: any, tag?: string) => void;
}

export type PaymentMethod = {
    title: string;
    icon: string;
    subTitle: string;
    payoutModeValue: string;
    modeIconUrl?: string;
    modeValue?: string;
    tagData?: {
        text: string;
        bgHex: string;
        textHex: string;
    }
}
export type initalPaymentMethod = {
    title?: string;
    iconUrl?: string;
    subTitle?: string;
    paymentModeValue?: string;
    modeIconUrl?: string;
    modeValue?: string;
    tagData?: {
        text: string;
        bgHex: string;
        textHex: string;
    }
}

export type InitialPaymentMethodAvaliableProps = {
    selectInitailConfrimMethod: () => void;
}

export type PaymentMethodsProps = {
    paymentMethod: PaymentMethod[];
    tag?: string;
}

export type InitialPaymentMethodsProps = {
    paymentMethod: initalPaymentMethod;
    tag?: string;
}

export type ConfirmPaymentProps = {
    selectedPaymentMethod?: any;
    selectedInitalPaymentMethod?: any;
    errorTranscationMessage?: ()=>void;
    processPaymentMessage?: ()=>void;
    successTranscationMessage?: ()=>void;
}

export type transactionsHistoryData = {
    tid: number;
    timestamp: number;
    transactionType: number;
    orderId: number;
    isPending: boolean;
    icon: string;
    amount: string;
    transactionHeaderDisplayText: string;
    transactionHeaderType: string;
    transactionLabel: {
        displayText: string;
        showChip: boolean;
        chipBackgroundColor: string;
    }[];
    transactionDetailLabel: {
        displayText: string;
        value: string;
    }[];
}

export type PaymentCardsProps = {
    transactionsHistory?: transactionsHistoryData[];
    transactionHistoryCount?: number;
    checkScroll?: boolean;
    }

export type NavigationProps = {
        isFixed?: boolean;
      }

export type CalenderProps = {
    isOpenCalender?: boolean;
    closeCalenderHandler?: () => void;
    t?: any;
}

export type WithdrawCardBoxProps = {
    openOneClickWithdrawal: (openTrue: boolean) => void;
    CardData: CardData;
  }
  
export type CardData = {
        headerText: string;
        withdrawNowCta: WithdrawButton;
        withdrawableAmount: string;
  }
  
export type WithdrawButton = {
    displayText?: string;
  }

  export type CardDataProps = {
    pendingPayoutTxt?: string;
    pendingPayouts?: number;
  }
  
  export type ReferralCardProps = {
    redirectToUrl: string;
    CardData: CardDataProps;
  }

  export type IToken = string;

export enum IDataType {
    string = 'string',
    number = 'number',
    bool = 'bool',
    array = 'array',
    object = 'object',
}

export const RJT = 'RJT'

export type ApiResponseUseQuery =  any;
export type ApiResponseUseQueryError =  any;

export type CSEData = {
    enabled: boolean;
    email?: string;
    envId?: string;
    envType?: string;
    baseUrl?: string;
  }